import { denormalize } from "normalizr";

import { payment } from "../../../api/schema";

export default state => {
  try {
    const items = state.payments.ids;
    const denormalized = denormalize(
      { items },
      { items: [payment] },
      state.entities
    );
    return denormalized.items;
  } catch (err) {
    return [];
  }
};
